'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

/* Views */
var List = require('./list')
var EditNew = require('./edit_new')

var SchedulesModule = function () {
  /* Routes ----------------------------------------------------------------- */
  /* API -------------------------------------------------------------------- */
  var API = {
    listSchedules: function (options) {
      let list = new List(options)
    },
    editNewSchedule: function (options) {
      let edit = new EditNew(options)
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('schedule:list', function (options) {
    API.listSchedules(options)
  })

  App.globalChannel.on('schedule:new', function (options) {
    options['region'] = App.rootLayout.getRegion('dialogRegion')
    API.editNewSchedule(options)
  })

  App.globalChannel.on('schedule:edit', function (options) {
    options['region'] = App.rootLayout.getRegion('dialogRegion')
    API.editNewSchedule(options)
  })
}

module.exports = SchedulesModule



// WEBPACK FOOTER //
// ./js/modules/schedules/index.js